import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';
import {ColumnFilter} from "primeng/table/table";
import {A} from "@angular/cdk/keycodes";
import {FilterMetadata, PrimeNGConfig} from "primeng/api";

@Component({
  selector: 'app-column-filter-field-constraints-view',
  templateUrl: './column-filter-field-constraints-view.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnFilterFieldConstraintsViewComponent implements OnInit {
  @Input() filter: ColumnFilter;
  @ContentChild('valueTemplate') valueTemplate: TemplateRef<any>;
  Array = Array;
  constructor(private changeDetectorRef: ChangeDetectorRef, public config: PrimeNGConfig) {

  }

  ngOnInit(): void {
  }

  ngAfterViewChecked(){
    this.changeDetectorRef.detectChanges();
  }

  onFilter = value => {
    if(!this.filter){
      return;
    }

    if (this.filter.fieldConstraints) {
      this.filter.fieldConstraints[0].value = value;
    } else {
      this.filter.dt.filters[this.filter.field] = [{
        matchMode: this.filter.matchMode,
        operator: this.filter.operator,
        value: value
      }];
    }
    this.filter.dt._filter()
  };
  protected readonly A = A;

  toggleMore(constraint: FilterMetadata) {

  }
}
